import { IconProps } from "@kernel/react-icons";
import React, { useMemo, useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Layout, LazyModuleLayout } from "@kernel/react-ui-kit";

export interface LayoutRouteProps {
  logo: string;
  customer: string;
  footerEnabled: boolean;
  title: string;
  version: string;
  module: string;
  copyRightIcon?: IconProps;
  headerClassname?: string;
  footerClassname?: string;
}

export function LayoutRoute({
  logo,
  customer,
  footerEnabled,
  title,
  version,
  module,
  copyRightIcon,
  headerClassname,
  footerClassname
}: LayoutRouteProps) {
  const Component = React.lazy(() => import(`../${module}/index.tsx`));
  useEffect(() => {
    document.title = title;
  }, [title]);
  const renderHeader = useMemo(
    () => () => (
      <Header title={title} logo={logo} className={headerClassname} />
    ),
    [title, logo, headerClassname]
  );
  const renderFooter = useMemo(
    () => () => (
      <Footer
        customer={customer}
        title={title}
        version={version}
        copyRightIcon={copyRightIcon}
        className={footerClassname}
      />
    ),
    [customer, title, version, copyRightIcon, footerClassname]
  );
  return (
    <Layout
      header={renderHeader}
      footer={footerEnabled ? renderFooter : undefined}
      className="webcall"
    >
      <LazyModuleLayout
        module={module}
        component={Component}
        moduleClassName="p-0"
      />
    </Layout>
  );
}
